import { useQuery } from '@tanstack/react-query';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import DamagedPointsIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/damagedPointsIcon.svg?react';
import IndividualDocumentsIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/individualDocumentsIcon.svg?react';
import VehicleImageIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/vehicleImageIcon.svg?react';
import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import CardButton from '@/common/components/cardButton/CardButton';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';
import useModal from '@/common/hooks/useModal';
import {
  BodyDamagedVehicleCorrectiveImageTabType,
  BodyVehicleCorrectiveImageNameType,
} from '@/modules/adjusterReportModules/Insurer-information/types/Bodyimages';
import BodyCorrectiveImageModal from '@/modules/adjusterReportModules/Insurer-information/components/images/correctiveImages/components/bodyInquiredForm/components/modals/BodyCorrectiveImageModal';
import getBodyVehicleCorrectiveImagesFormTabsOptions from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyVehicleCorrectiveImagesFormTabs/getBodyVehicleCorrectiveImagesFormTabsOptions';
export const BodyInquiredFormTabs = () => {
  const { id } = useParams();
  const { closeModal, open, openModal } = useModal();
  const [type, setType] = useState<BodyVehicleCorrectiveImageNameType>(
    BodyVehicleCorrectiveImageNameType.documents,
  );
  const { data, isPending } = useQuery(
    getBodyVehicleCorrectiveImagesFormTabsOptions({
      id: +id!,
    }),
  );

  return (
    <Box
      className={css({
        paddingTop: '2rem',
        width: '100%',
      })}
    >
      {isPending ? (
        <Box display="flex" alignItems="center" justifyContent="center">
          <CircularLoading color="colors.purple-primary" />
        </Box>
      ) : (
        <>
          {data?.map((item) => (
            <CardButton
              key={item?.name}
              cardProps={{
                className: css({ marginY: '1rem' }),
                onClick: () => {
                  openModal();

                  setType(BodyVehicleCorrectiveImageNameType[item?.name]);
                },
              }}
              hasArrow
              renderIcon={() => renderIcon(item?.name)}
              title={item?.fa_name}
            />
          ))}
        </>
      )}
      <BodyCorrectiveImageModal
        open={open}
        closeModal={closeModal}
        type={type}
      />
    </Box>
  );
};

export default BodyInquiredFormTabs;

const renderIcon = (
  tabName: BodyDamagedVehicleCorrectiveImageTabType['name'],
) => {
  let tabIcon: Record<
    BodyDamagedVehicleCorrectiveImageTabType['name'],
    React.JSX.Element
  > = {
    documents: <IndividualDocumentsIcon />,
    vehicle: <VehicleImageIcon />,
    damaged_parts: <DamagedPointsIcon />,
  };
  return tabIcon[tabName];
};
